import React, { ReactNode } from 'react';

interface Props {
  children?: ReactNode | ReactNode[] | string;
}
export default function PageContainer({ children }: Props) {
  return <div className="min-h-[calc(100vh-100px)] bg-white">{children}</div>;
}
